import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { UserService } from "src/app/shared/services/user.service";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("AuthGuard");
    const userLoaded = await this.userServices.userLoaded();

    console.log({ userLoaded });

    if (!userLoaded) {
      console.log("No esta logueado");
      this.logOut(state);
      return false;
    } else {
      if (this.userServices.user && this.userServices.user.loginDate) {
        let loginDate = new Date(this.userServices.user.loginDate);
        let dif = this.days_between(new Date(), loginDate);

        //Si tiene mas de un dia logueado
        if (dif > 0 && environment.production) {
          this.logOut(state);
          return false;
        } else {
          return true;
        }
      } else {
        this.logOut(state);

        return false;
      }
    }
  }
  logOut(state) {
    console.log("logOut");

    this.userServices.logOut();
    this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
    return false;
  }
  days_between(date1, date2) {
    // The number of milliseconds in one day
    const ONE_DAY = 1000 * 60 * 60 * 24;
    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);
    // Convert back to days and return
    return Math.round(differenceMs / ONE_DAY);
  }
}
// Desloagueado
@Injectable({
  providedIn: "root",
})
export class OutGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("OutGuard");
    const userLoaded = await this.userServices.userLoaded();
    console.log({ userLoaded });

    if (userLoaded) {
      this.router.navigate(["/pages/dashboard"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
    return true;
  }
}
// Lead Guard
@Injectable({
  providedIn: "root",
})
export class LeadGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("LeadGuard");

    console.log(this.userServices.user);

    if (this.userServices.user && this.userServices.user.token) {
      return true;
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class PayGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "PayComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
@Injectable({
  providedIn: "root",
})
export class SettleGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "SettleComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class CreditorsGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "CreditorsComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class LogsGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "LogsComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class PendingGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "PendingComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
@Injectable({
  providedIn: "root",
})
export class UsersGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "UsersComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class ViewsGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "ViewsComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "RoleComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: "root",
})
export class ProgramGuard implements CanActivate {
  constructor(
    private router: Router,
    public userServices: UserService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userServices.user && this.userServices.user.roles) {
      let result = this.userServices.user.roles.find((e) => {
        return e.component == "ProgramComponent";
      });

      if (result) return true;
      else {
        this.router.navigate(["/pages/not-found"], {
          queryParams: { returnUrl: state.url },
        });
        return false;
      }
    } else {
      this.router.navigate(["/pages/not-found"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
